/**
 * @deprecated `Screens` will be removed.Please use MEDIA["lg"] from `ui/shared/constants` instead.
 */
export const Screens = new Map([
    ["sm", "min-width: 640px"],
    ["md", "min-width: 768px"],
    ["lg", "min-width: 1024px"],
    ["xl", "min-width: 1280px"],
    ["2xl", "min-width: 1536px"]
]);
